import { configureStore } from '@reduxjs/toolkit'
import signupReducer from './features/signup/signupSlice';

export const store = configureStore({
  reducer: {
    signup: signupReducer,
  }
});

export const getRecaptchaToken = () => {
  const state = store.getState();
  return state.signup.recaptchaToken;
}

export const getSmsSessionId = () => {
  const state = store.getState();
  return state.signup.smsSessionId;
}

export const getOtpValidated = () => {
  const state = store.getState();
  return state.signup.otpValidated;
}

export const getFormHash = () => {
  const state = store.getState();
  return state.signup.formHash;
}

export const getFormSubmitted = () => {
  const state = store.getState();
  return state.signup.formSubmitted;
}

export const getSelectedVolumeTier = () => {
  const state = store.getState();
  return state.signup.selectedVolumeTier;
}
